const deployEnv = process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'prod' : 'alpha';

export const isAlpha = deployEnv === 'alpha';

export const DISTRIBUTOR = Object.freeze({
  CPCPAY: 'CPCPAY',
  CITIMKT: 'CITIMKT',
  CATHAYMR: 'CATHAYMR',
  LINE_BANK: 'LINE_BANK',
  IKNOW99: 'IKNOW99',
  AUTO_PARTNER: 'AUTO_PARTNER',
  NPCPAY: 'NPCPAY',
  TEST: 'TEST',
});

export const CITY_IDS = Object.freeze({
  newTaipeiCity: 'new_taipei_city',
  hsinchuCounty: 'hsinchu_county',
  hsinchuCity: 'hsinchu_city',
  taoyuan_Cty: 'taoyuan_city',
  keelungCity: 'keelung_city',
  taichungCity: 'taichung_city',
  chiayiCity: 'chiayi_city',
  tainanCity: 'tainan_city',
  kaohsiungCity: 'kaohsiung_city',
  hualienCounty: 'hualien_county',
  taitungCounty: 'taitung_county',
  penghuCounty: 'penghu_county',
  yilanCounty: 'yilan_county',
});

export const distributor = () => {
  switch (process.env.REACT_APP_DISTRIBUTOR) {
    case 'CATHAYMR':
      return DISTRIBUTOR.CATHAYMR;
    case 'CPCPAY':
      return DISTRIBUTOR.CPCPAY;
    case 'CITIMKT':
      return DISTRIBUTOR.CITIMKT;
    case 'LINE_BANK':
      return DISTRIBUTOR.LINE_BANK;
    case 'IKNOW99':
      return DISTRIBUTOR.IKNOW99;
    case 'AUTO_PARTNER':
      return DISTRIBUTOR.AUTO_PARTNER;
    case 'NPCPAY':
      return DISTRIBUTOR.NPCPAY;
    case 'TEST':
      return DISTRIBUTOR.TEST;
    default:
      return '';
  }
};

export const distributorName = () => {
  switch (process.env.REACT_APP_DISTRIBUTOR) {
    case 'CATHAYMR':
      return '國泰優惠';
    case 'CPCPAY':
      return '中油Pay';
    case 'CITIMKT':
      return '行動市集';
    case 'LINE_BANK':
      return 'LINE Bank';
    case 'IKNOW99':
      return 'iKnow99';
    case 'AUTO_PARTNER':
      return 'AutoPartner';
    case 'NPCPAY':
      return '全國';
    case 'TEST':
      return '內部人員測試用';
    default:
      return '';
  }
};

export const isCathaymr = distributor() === DISTRIBUTOR.CATHAYMR;
export const isCpcpay = distributor() === DISTRIBUTOR.CPCPAY;
export const isCitimkt = distributor() === DISTRIBUTOR.CITIMKT;
export const isLineBank = distributor() === DISTRIBUTOR.LINE_BANK;
export const isIknow99 = distributor() === DISTRIBUTOR.IKNOW99;
export const isAutoPartner = distributor() === DISTRIBUTOR.AUTO_PARTNER;
export const isNpcpay = distributor() === DISTRIBUTOR.NPCPAY;
export const isTest = distributor() === DISTRIBUTOR.TEST;
export const isSupportPass = isCathaymr || isCitimkt || isAutoPartner || isTest;

const commonAlphaConfig = {
  autopassUrl: 'https://www-alpha.pklotcorp.com',
  mochipayUrl: 'https://alpha-mochipay.pklotcorp.com',
  apiUrl: 'https://api-alpha.pklotcorp.com',
  paymentUrl: 'https://payment-alpha.mochipay.xyz',
  broker: 'broker-alpha.pklotcorp.com',
  autopassIntroUrl: 'https://autopass-intro-alpha-mochipay.pklotcorp.com',
  mochipayIntroUrl: 'https://intro-alpha-mochipay.pklotcorp.com',
  amplitudeKey: 'f86a3df1a4a2bed2e07b21c20388a8c2',
  mapUrl: 'https://maps-alpha.pklotcorp.com',
  contactFormUrl: 'https://contact-alpha.pklotcorp.com',
  mochiPassUrl: 'https://pklotcorp.com/mochi_pass',
};

const commonProdConfig = {
  autopassUrl: 'https://autopass.xyz',
  mochipayUrl: 'https://mochipay.xyz',
  apiUrl: 'https://api.autopass.xyz',
  paymentUrl: 'https://payment.mochipay.xyz',
  broker: 'broker.autopass.xyz',
  autopassIntroUrl: 'https://autopass-intro.mochipay.xyz',
  mochipayIntroUrl: 'https://intro.mochipay.xyz',
  amplitudeKey: '0c190da3e551d84054f19759f0714d91',
  mapUrl: 'https://maps.autopass.xyz',
  contactFormUrl: 'https://contact.autopass.xyz',
  mochiPassUrl: 'https://autopass.xyz/mochi_pass',
};

const cathaymrAlphaConfig = {
  introUrl: 'https://cathay-my-rewards-intro-alpha-mochipay.pklotcorp.com',
  clientUid: 'b9fcf809e328db19afa070bff10df85b20bd960b5fe2acc544721018db616f60',
  distributorUid: '890ab4fb-9c00-4026-8019-16e96af06184',
  sentryUrl: 'https://e1c6ab50f9e64b038a5090d2591e1c0b@sentry.io/1382812',
  googleAnalyticsCode: 'UA-124196431-4',
  googleOptimizeContainerCode: 'OPT-PPSV7CX',
  googleOptimizeExperimentID: 'I1n5VfO8RX6efgFjEI3iwg',
};

const cathaymrProdConfig = {
  introUrl: 'https://cathay-my-rewards-intro.mochipay.xyz',
  clientUid: '492bdb81e6c7d2b711a72ac58247970a8b2b420f3e0d0e83d6fff1c77d210247',
  distributorUid: 'ff191d76-8bcb-45f8-929f-05d9e1a13c79',
  sentryUrl: 'https://a25e37fbab1243d4821da9dbbc60e6f8@sentry.io/1382813',
  googleAnalyticsCode: 'UA-124196431-4',
  googleOptimizeContainerCode: 'OPT-PPSV7CX',
  googleOptimizeExperimentID: 'muAKEHiZRRqXHV6yq-y1Mg',
};

const cpcpayAlphaConfig = {
  introUrl: 'https://cpcpay-intro-alpha-mochipay.pklotcorp.com',
  clientUid: 'bcff0c33c2dc6a79babb27e4809d7429d17a7758d35f861c42ddf36e6c10b00c',
  distributorUid: '974b674f-7c37-4d7e-aae1-86bb04c13c3b',
  sentryUrl: 'https://c35a49f1ff6d46d49aa3f3a5b2458ee0@o121681.ingest.sentry.io/1889477',
  googleAnalyticsCode: 'UA-124196431-15',
  googleOptimizeContainerCode: 'OPT-PDNWRHK',
  googleOptimizeExperimentID: 'JI8ztWiaRA6sUfVpqJa8zQ',
};

const cpcpayProdConfig = {
  introUrl: 'https://cpcpay-intro.mochipay.xyz',
  clientUid: 'faaa5a2d6cbe1ce16b6830efac52c128d202309a07309a7afdef023c058361fe',
  distributorUid: '6e6fa152-58dc-42b3-aabe-4d2e4216b792',
  sentryUrl: 'https://90d637e347914467b8fc7c7054056856@o121681.ingest.sentry.io/6088626',
  googleAnalyticsCode: 'UA-124196431-15',
  googleOptimizeContainerCode: 'OPT-PDNWRHK',
  googleOptimizeExperimentID: '7nnxNFsQS2S2Mb2qoXdLVA',
};

const citimktAlphaConfig = {
  introUrl: 'https://citibank-marketplace-intro-alpha-mochipay.pklotcorp.com',
  clientUid: '08f82dd8a4b021a5d80188be76094ea115ef4f1a89811356fb0e4cce9aad3961',
  distributorUid: '21207180-0d7c-40cd-899e-34d7133a5405',
  sentryUrl: 'https://c35a49f1ff6d46d49aa3f3a5b2458ee0@sentry.io/1889477',
  googleAnalyticsCode: 'UA-124196431-16',
  googleOptimizeContainerCode: 'OPT-WWZTLLB',
  googleOptimizeExperimentID: 'lHTs0h3dQG-5RvgKMHYShw',
};

const citimktProdConfig = {
  introUrl: 'https://citibank-marketplace-intro.mochipay.xyz',
  clientUid: 'cb41a7c3c8aa249fce70e78c8c3c8d0e91b32c3263fee247769e1c6a157bac19',
  distributorUid: '36417436-3233-458e-8067-f5690c5a06ef',
  sentryUrl: 'https://ffe3751ef0724b8e9714ede08cef0382@sentry.io/1889480',
  googleAnalyticsCode: 'UA-124196431-16',
  googleOptimizeContainerCode: 'OPT-WWZTLLB',
  googleOptimizeExperimentID: 'N2nDmWwIQcOGOybkrkaPxw',
};

const linebankAlphaConfig = {
  introUrl: 'https://line-bank-intro-alpha-mochipay.pklotcorp.com',
  clientUid: 'BFLA0qfahaAJlC1SxJpu5EtUvc8wSCXDmDR3hmlOn3Y',
  distributorUid: '23f79d32-7137-4dd0-b2b4-9f775934a48a',
  sentryUrl: 'https://76a38c143d6b4c3dbfe5d8102fc25174@o121681.ingest.sentry.io/6312462',
  googleAnalyticsCode: 'G-S3E4TD8VDR',
  linebankMainPage: 'https://line-beta.me/R/fin/bk/1554102018-rgaMVpVM/eco-hub/main',
  lineBankBindPage:
    'https://line-beta.me/R/fin/bk/1554102018-rgaMVpVM/eco-hub/landing?serviceCode=Autopass_CardBinding',
  lineBankLicensePlatesPage: 'https://line-beta.me/R/fin/bk/1554102018-rgaMVpVM/eco-hub/manage-vehicle-plates ',
  lineBankHelperUrl: 'https://www.linebank.com.tw/support/faq/category/10',
};

const linebankProdConfig = {
  introUrl: 'https://line-bank-intro.mochipay.xyz',
  clientUid: '2ecAMkCFnu50162eHJTwTRgzd3QwhrgsqMj14zQ0mnc',
  distributorUid: '33311681-a575-46fe-998f-50327dc97b04',
  sentryUrl: 'https://0bd4af60673a447eb8cfb1543b5f5337@o121681.ingest.sentry.io/6312460',
  googleAnalyticsCode: 'G-S3E4TD8VDR',
  linebankMainPage: 'https://line.me/R/fin/bk/1612609319-qJbaOpWn/eco-hub/main ',
  lineBankBindPage: 'https://line.me/R/fin/bk/1612609319-qJbaOpWn/eco-hub/landing?serviceCode=Autopass_CardBinding ',
  lineBankLicensePlatesPage: 'https://line.me/R/fin/bk/1612609319-qJbaOpWn/eco-hub/manage-vehicle-plates',
  lineBankHelperUrl: 'https://www.linebank.com.tw/support/faq/category/10',
};

const iknow99AlphaConfig = {
  introUrl: 'https://iknow99-intro-alpha-mochipay.pklotcorp.com',
  clientUid: '7dJqyHNieVRJ7sFofvEElAi1X7Tj5DAF_MCe3s6S7cc',
  distributorUid: '30fcb906-fb8c-474e-ab71-a67a03e9157b',
  sentryUrl: 'https://9d5696172ae348518c9e270270f650d1@o121681.ingest.sentry.io/6312459',
  googleAnalyticsCode: '',
};

const iknow99ProdConfig = {
  introUrl: 'https://iknow99-intro.mochipay.xyz',
  clientUid: 'PDNMGnwiHpH0vonZuJQCYU8WaZRd8B4SdbCfMr5jNdA',
  distributorUid: '8fc29c46-e8ed-47d7-b0ac-2212f6bff3f3',
  sentryUrl: 'https://c8f15aac15f140c29ae5d041a83b43ae@o121681.ingest.sentry.io/6312455',
  googleAnalyticsCode: '',
};

const autoPartnerAlphaConfig = {
  introUrl: 'https://autopartner-intro-alpha-mochipay.pklotcorp.com',
  clientUid: 'OO_IGjM0NFAfKH2UC6nL2f-StRFcjDvFtcTnGiDyEbc',
  distributorUid: 'b6e3160a-a8d9-4a14-80bd-c04200b719cc',
  sentryUrl: 'https://6fbe0db6fb614bf583205bc1058bd673@o121681.ingest.sentry.io/6312464',
  googleAnalyticsCode: '',
};

const autoPartnerProdConfig = {
  introUrl: 'https://autopartner-intro.mochipay.xyz',
  clientUid: 'EP6DskS5UXZ4lgFmIQcHu7NGpyzbwzLvr8VAIqqXecE',
  distributorUid: '59c26161-40d1-41fd-8542-25de722c26d0',
  sentryUrl: 'https://e54acbd7b87343f990869f4c3018c0be@o121681.ingest.sentry.io/6312463',
  googleAnalyticsCode: '',
};

const npcAlphaConfig = {
  introUrl: 'https://npc-intro-alpha-mochipay.pklotcorp.com',
  clientUid: '77_fkgtIBKNsPqRM5Eo-UEkNv5aNZmMnDFayNLtB1dE',
  distributorUid: '2f18a2ae-b59b-4a51-a58c-e24cf713d842',
  sentryUrl: 'https://14e8de92d20b47949f1c4c9645726aac@o121681.ingest.sentry.io/6474406',
  googleAnalyticsCode: '',
};

const npcProdConfig = {
  introUrl: 'https://npc-intro.mochipay.xyz',
  clientUid: 'vXqMc68EGmKxu_UoGRdGlb4cJRbQY1pohY_5VrODBpo',
  distributorUid: '27d5a6c4-dd75-43ad-9fb0-d8dcaadaed42',
  sentryUrl: 'https://dcce19adbe6e43f6b61c56e69bf93d59@o121681.ingest.sentry.io/6474399',
  googleAnalyticsCode: '',
};

const testAlphaConfig = {
  introUrl: 'https://intro-alpha-mochipay.pklotcorp.com',
  clientUid: 'b9fcf809e328db19afa070bff10df85b20bd960b5fe2acc544721018db616f60',
  distributorUid: '890ab4fb-9c00-4026-8019-16e96af06184',
  sentryUrl: '',
  googleAnalyticsCode: '',
};

const testProdConfig = {
  introUrl: 'https://intro.mochipay.xyz',
  clientUid: '492bdb81e6c7d2b711a72ac58247970a8b2b420f3e0d0e83d6fff1c77d210247',
  distributorUid: 'ff191d76-8bcb-45f8-929f-05d9e1a13c79',
  sentryUrl: '',
};

const distributorConfig = {
  alpha: {
    [DISTRIBUTOR.CATHAYMR]: cathaymrAlphaConfig,
    [DISTRIBUTOR.CPCPAY]: cpcpayAlphaConfig,
    [DISTRIBUTOR.CITIMKT]: citimktAlphaConfig,
    [DISTRIBUTOR.LINE_BANK]: linebankAlphaConfig,
    [DISTRIBUTOR.IKNOW99]: iknow99AlphaConfig,
    [DISTRIBUTOR.AUTO_PARTNER]: autoPartnerAlphaConfig,
    [DISTRIBUTOR.NPCPAY]: npcAlphaConfig,
    [DISTRIBUTOR.TEST]: testAlphaConfig,
  },
  prod: {
    [DISTRIBUTOR.CATHAYMR]: cathaymrProdConfig,
    [DISTRIBUTOR.CPCPAY]: cpcpayProdConfig,
    [DISTRIBUTOR.CITIMKT]: citimktProdConfig,
    [DISTRIBUTOR.LINE_BANK]: linebankProdConfig,
    [DISTRIBUTOR.IKNOW99]: iknow99ProdConfig,
    [DISTRIBUTOR.AUTO_PARTNER]: autoPartnerProdConfig,
    [DISTRIBUTOR.NPCPAY]: npcProdConfig,
    [DISTRIBUTOR.TEST]: testProdConfig,
  },
};

const commonConfig = isAlpha ? commonAlphaConfig : commonProdConfig;

export const config = { ...distributorConfig[deployEnv][distributor()], ...commonConfig };

export const termsUrl = `${config.autopassUrl}/terms`;
export const privacyUrl = `${config.autopassUrl}/privacy`;
export const marketingConsentUrl = `${config.autopassUrl}/marketing-consent`;
export const payTaipeiCardlessParkingTermsUrl = `${config.autopassUrl}/pay_taipei_cardless_parking_terms`;

export const introRefuelingUrl = `${config.introUrl}/refueling`;
export const introGasStationUrl = `${config.introUrl}/gas-stations`;
export const introParkingUrl = `${config.introUrl}/parking`;
export const introOnStreetParkingUrl = `${config.introUrl}/on-street-parking`;
export const introPromotionUrl = `${config.introUrl}/promotion`;

export const helperUrl = `https://help.mochipay.xyz/`;
export const autoPayingIntercomUrl = 'https://help.mochipay.xyz/street-parking/autopay/bills';
export const maintenanceConfigUrl = isAlpha
  ? 'https://maintenance-alpha.pklotcorp.com/config.json'
  : 'https://maintenance.autopass.xyz/config.json';

export const ISO8601 = 'YYYY-MM-DDTHH:mm:ssZ';

export const PATH = Object.freeze({
  // main
  MAIN: '/main',
  MAPS: '/maps',
  ORDERS: '/orders',
  ORDER_DETAIL: '/order-details',
  COINS: '/coins',
  SETTINGS: '/settings',
  PROFILE_SETTING: '/profile-setting',
  COUPON: '/coupon',
  COUPON_EXPIRED: '/coupon/expired',
  COUPON_EXCHANGE: '/coupon/exchange',
  PROMOTION: '/promotion',
  SERVICE_INSTRUCTION: '/service-instruction',
  // license plates
  LICENSE_PLATES_INDEX: '/license-plates',
  LICENSE_PLATES_NEW: '/license-plates/new',
  LICENSE_PLATES_EDIT: '/license-plates/:id/edit',
  // receipt
  RECEIPT_INDEX: '/receipt',
  RECEIPT_DONATE: '/receipt/donate',
  // street parking
  STREET_PARKING_INDEX: '/street-parking',
  STREET_PARKING_AUTOPAY: '/street-parking/autopay',
  STREET_PARKING_CITIES: '/street-parking/cities',
  STREET_PARKING_PLATES: '/street-parking/plates',
  STREET_PARKING_BILLS: '/street-parking/bills',
  // payment
  MOCHIPAY_FLOW_INDEX: '/mochi-pay-flow',
  MOCHIPAY_FLOW_SETTING: '/mochi-pay-flow/setting',
  MOCHIPAY_FLOW_CONFIRM: '/mochi-pay-flow/confirm',
  MOCHIPAY_FLOW_CREDIT_CARD: '/mochi-pay-flow/credit-card',
  // user
  USER_INDEX: '/user',
  USER_WELCOME: '/user/welcome',
  USER_LOGIN: '/user/login',
  USER_REGISTER: '/user/register',
  USER_ENABLE_ON_STREET_PARKING_AUTO_PAY: '/user/enable-on-street-parking-auto-pay',
  USER_ADD_PLATE_NUMBER: '/user/add-plate-number',
  USER_ACTIVATE_PLATE_NUMBER: '/user/activate-plate-number',
  USER_BIND_CPC_PAY_CARD: '/user/bind-cpc-pay-card',
  USER_BIND_NPC_CARD: '/user/bind-npc-card',
  USER_BIND_CARD: '/user/bind-card',
  USER_ON_STREET_PARKING_AUTO_PAY_NOTICE: '/user/on-street-parking-auto-pay-notice',
  // else
  SHORTCUT_INSTRUCTION: '/shortcut-instruction',
  EXPIRED: '/expired',
  CONTACT: '/contact',
  SCAN_PAY: '/scan-pay',
});
